// Tag Closuure Validation Buttons
import React from "react";
import CButton from "../../common/CButton";
import useStyles from "./TagClosure_Styles";

export default function ButtonWidget(props) {
const styles = useStyles();
 const vehicleLength = props?.vehicleLength
 const finalRefundAmount =  props?.finalRefundAmount
 const prevChequeImg = props?.prevChequeImg
 const lastWithCCBtnEnable = props?.lastWithCCBtnEnable
const lastWithoutCCBtnEnableForAllDocs = props?.lastWithoutCCBtnEnableForAllDocs
const lastWithCCBtnEnableForAllDocs = props?.lastWithCCBtnEnableForAllDocs
const cancelChequeImg = props?.cancelChequeImg
const isdigiLockerSuccess = props?.isdigiLockerSuccess
const lastWithoutCCBtnEnableForEkyc = props?.lastWithoutCCBtnEnableForEkyc
const bankDetailsValidation = props?.bankDetailsValidation


  return (
    <>  {(vehicleLength > 1 && finalRefundAmount >= 1000 )  ?
                  <CButton title={'Close Tag '}
                    isDisabled={props?.otherTextValidation() && prevChequeImg !=""  ? false : true } 
                    onPress={() => {
                      props?.setClosureTagConfirmationModal(true)
                    }}
                    style={styles.closeTagBtn} />
                  : vehicleLength > 1  ?
                    <CButton title={'Close Tag '}
                    isDisabled={!props?.otherTextValidation()}
                    onPress={() => {
                        props?.setClosureTagConfirmationModal(true)
                    }}
                    style={styles.closeTagBtn} />
                  : null}
               
                { lastWithCCBtnEnable ?
                  <CButton title={'Close Tag'}
                    isDisabled={props?.otherTextValidation() && prevChequeImg !="" && bankDetailsValidation()  ? false : true}
                    onPress={() => {
                        props?.setClosureTagConfirmationModal(true)
                    }}
                    style={styles.closeTagBtn} />
                  : null
                }
                {lastWithoutCCBtnEnableForAllDocs ?
                  <CButton title={'Close Tag '}
                    isDisabled={props?.otherTextValidation() && props?.withoutCCAllDocsValid()  ? false : true}
                    onPress={() => {
                        props?.setClosureTagConfirmationModal(true)
                    }}
                    style={styles.closeTagBtn} />
                  : null
                }
                 {lastWithCCBtnEnableForAllDocs ?
                  <CButton title={'Close Tag'} // ---
                    isDisabled={ props?.otherTextValidation() && props?.withCCAllDocsValid()  && props?.bankDetailsValidation() ? false : true}
                    onPress={() => {
                        props?.setClosureTagConfirmationModal(true)
                    }}
                    style={styles.closeTagBtn} />
                  :  null
                }
                 {isdigiLockerSuccess && finalRefundAmount && finalRefundAmount < 1000?
                  <CButton title={'Close Tag '}
                    isDisabled={props?.otherTextValidation() && props?.bankDetailsValidation() ? false : true}
                    onPress={() => {
                        props?.setClosureTagConfirmationModal(true)
                    }}
                    style={styles.closeTagBtn} />
                  : null}
                   {isdigiLockerSuccess && finalRefundAmount && finalRefundAmount >= 1000 ?
                  <CButton title={'Close Tag'}
                    isDisabled={props?.otherTextValidation() && props?.bankDetailsValidation() && prevChequeImg !="" ? false : true}
                    onPress={() => {
                        props?.setClosureTagConfirmationModal(true)
                    }}
                    style={styles.closeTagBtn} />
                  : null}

                {lastWithoutCCBtnEnableForEkyc ?
                  <CButton title={'Close Tag'}
                    isDisabled={props?.otherTextValidation() && props?.bankDetailsValidation()  ? false : true}
                    onPress={() => {
                        props?.setClosureTagConfirmationModal(true)
                    }}
                    style={styles.closeTagBtn} />
                  : null
                }
    </>
  );
}

